import React, { useState } from "react";
import { Link } from "react-router-dom";
import strings from "../../../languages/strings";
import { Box, Button } from "@mui/material";
import ResetPasswordValidator from "../resetPasswordForm/ResetPasswordValidator";
import { TextField } from "mui-rff";
import { Form } from "react-final-form";
import { apiPost } from "../../../api/api";

const RequestPasswordResetForm = () => {
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  const basicProps = {
    variant: "standard" as "standard",
    sx: { marginTop: 2 },
  };

  const handleSubmit = (values: any) => {
    apiPost(
      "/users/forgotpassword",
      {
        username: values.email,
      },
      false
    )
      .then(() => {
        setMessage("Wachtwoord reset aangevraagd, u ontvangt een e-mail");
        setSuccess(true);
      })
      .catch((reason: any) => {
        console.error(reason);
      });
  };

  return (
    <div>
      <Box my={2}>
        {success ? (
          <div>{message}</div>
        ) : (
          <Form
            onSubmit={handleSubmit}
            initialValues={{}}
            validateOnBlur={false}
            render={({ handleSubmit }) => (
              <form noValidate onSubmit={handleSubmit}>
                <TextField
                  label={"E-mail"}
                  name="email"
                  type={"text"}
                  {...basicProps}
                />

                <Button
                  type="submit"
                  onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ marginTop: 5 }}
                >
                  {strings.passwordReset}
                </Button>
              </form>
            )}
          />
        )}
        <Box my={2}>
          <Link style={{ color: "black", fontSize: 14 }} to="/app">
            Terug naar inloggen
          </Link>
        </Box>
      </Box>
    </div>
  );
};

export default RequestPasswordResetForm;
